export default __webpack_public_path__ + "static/media/ftj.f69805d5.jpg";